import {
  UpdateUserSettingsDto,
  UserSettings,
} from "@/common/api/datasources/Api";
import { api } from "@/common/api/instance";

export type Theme = "light" | "dark" | "system";

export const userSettingsService = {
  getSettings: async (userUUID?: string): Promise<UserSettings> => {
    const response = await api.userSettings.userSettingsControllerGetSettings(
      userUUID ? { userUUID } : undefined
    );
    return response.data;
  },

  updateSettings: async (
    userUUID: string,
    data: UpdateUserSettingsDto,
  ): Promise<UserSettings> => {
    const response = await api.userSettings.userSettingsControllerUpdateSettings(userUUID, data);
    return response.data;
  },
};

export const useUserSettingsQuery = () => ({
  settingsQuery: {
    queryKey: ["user-settings"],
    queryFn: (userUUID?: string) => userSettingsService.getSettings(userUUID),
  },

  updateSettingsMutation: {
    mutationFn: ({ userUUID, data }: { userUUID: string; data: UpdateUserSettingsDto }) =>
      userSettingsService.updateSettings(userUUID, data),
  },
});
